import { useEffect, useState } from 'react';
import type { IMoodRecord } from '@shared/types';
import { useHomePagePreference } from '@/lib/useHomePagePreference';
import { useUserData } from '@/lib/userData/UserDataProvider';
import { parsePathname, redirect, useLocation } from '../../features/routing';
import { MoodCalendar } from './MoodCalendar';
import { MoodLogList } from './MoodLogList';

export const HomePage = () => {
  // console.log(`%cHomePage rendered`, 'background:orange; color:black;');
  const location = useLocation();
  const display = parsePathname(location).segments[1];

  const [userData] = useUserData();
  const [homePagePreference] = useHomePagePreference();
  const [moodRecords, setMoodRecords] = useState<IMoodRecord[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchMoodRecords = async () => {
      setIsLoading(true);
      const response = await fetch('/api/mood/get-mood-records');
      const data = await response.json();
      if (data.success) {
        setMoodRecords(data.moodRecords);
      } else {
        console.error('Error fetching mood records:', data.error);
      }
      setIsLoading(false);
    };

    if (display === 'log' || display === 'calendar') {
      console.log(`%cthis is the display:`, 'background:pink; color:black;', display);
      fetchMoodRecords();
    } else if (homePagePreference) {
      console.log(
        `%cshould navigate to /home/${homePagePreference}`,
        'background:pink; color:black;'
      );
      redirect(`/home/${homePagePreference}`);
    }
  }, [display, homePagePreference, redirect]);

  if (!userData) {
    // @TODO: Show a login screen.
    return <div>User not found</div>;
  }

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (display === 'calendar') {
    return <MoodCalendar moodRecords={moodRecords} isLoading={isLoading} />;
  } else if (display === 'log') {
    return <MoodLogList moodRecords={moodRecords} isLoading={isLoading} />;
  } else {
    return null;
  }
};
